// ✅ Trekkin.app — alertsQueue.js
// -----------------------------------------------------------------------------
// 🔹 Guarda alertas pendentes (offline) em IndexedDB
// -----------------------------------------------------------------------------

const DB_NAME = "trekkin-alerts-queue";
const STORE_NAME = "pending_alerts";
const DB_VERSION = 1;

function openDB() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") {
      reject(new Error("indexedDB unavailable"));
      return;
    }
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "id" });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function enqueuePendingAlert(entry) {
  const db = await openDB().catch(() => null);
  if (!db) return false;
  return new Promise((resolve, reject) => {
    try {
      const tx = db.transaction(STORE_NAME, "readwrite");
      tx.objectStore(STORE_NAME).put(entry);
      tx.oncomplete = () => {
        db.close();
        resolve(true);
      };
      tx.onerror = () => {
        db.close();
        reject(tx.error);
      };
    } catch (e) {
      db.close();
      reject(e);
    }
  });
}

export async function listPendingAlerts() {
  const db = await openDB().catch(() => null);
  if (!db) return [];
  return new Promise((resolve, reject) => {
    try {
      const tx = db.transaction(STORE_NAME, "readonly");
      const req = tx.objectStore(STORE_NAME).getAll();
      req.onsuccess = () => {
        db.close();
        resolve(req.result || []);
      };
      req.onerror = () => {
        db.close();
        resolve([]);
      };
      tx.onerror = () => {
        db.close();
        resolve([]);
      };
    } catch (e) {
      db.close();
      resolve([]);
    }
  });
}

export async function removePendingAlert(id) {
  const db = await openDB().catch(() => null);
  if (!db) return false;
  return new Promise((resolve, reject) => {
    try {
      const tx = db.transaction(STORE_NAME, "readwrite");
      tx.objectStore(STORE_NAME).delete(id);
      tx.oncomplete = () => {
        db.close();
        resolve(true);
      };
      tx.onerror = () => {
        db.close();
        reject(tx.error);
      };
    } catch (e) {
      db.close();
      reject(e);
    }
  });
}
